import script from "./SchoolBox.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolBox.vue?vue&type=script&setup=true&lang=js"

import "./SchoolBox.vue?vue&type=style&index=0&id=66e1eab7&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66e1eab7"]])

export default __exports__